<template>
    <div>
        <form @submit.prevent="onSubmit">
            <rInput label="Nombres"
                placeholder="Escribe los nombres"
                :class="{ 'form-group--error': $v.inspirado.nombres.$error }"
                type="text"
                v-model.trim="$v.inspirado.nombres.$model"
                :isRequired="true"
            >
                <template v-slot:message-bottom>
                    <span v-if="$v.inspirado.nombres.$dirty && !$v.inspirado.nombres.required" class="text-danger">
                        <small>El nombre es un campo obligatorio</small><br />
                    </span>
                </template>
            </rInput>
            <rInput label="Apellidos"
                placeholder="Escribe los apellidos"
                :class="{ 'form-group--error': $v.inspirado.apellidos.$error }"
                type="text"
                v-model.trim="$v.inspirado.apellidos.$model"
                :isRequired="true"
            >
                <template v-slot:message-bottom>
                    <span v-if="$v.inspirado.apellidos.$dirty && !$v.inspirado.apellidos.required" class="text-danger">
                        <small>El apellido es un campo obligatorio</small><br />
                    </span>
                </template>
            </rInput>
            <rInput label="Edad"
                placeholder="Escribe tu edad actual"
                :class="{ 'form-group--error': $v.inspirado.edad.$error }"
                type="number"
                v-model.trim="$v.inspirado.edad.$model"
                :isRequired="true"
            >
                <template v-slot:message-bottom>
                    <span v-if="$v.inspirado.edad.$dirty && !$v.inspirado.edad.required" class="text-danger">
                        <small>La edad es un campo obligatorio</small><br />
                    </span>
                    <span v-if="$v.inspirado.edad.$dirty && !$v.inspirado.edad.validAge" class="text-danger">
                        <small>La edad ingresada no es válida</small><br />
                    </span>
                </template>
            </rInput>
            <Select label="Tipo de identificación"
                placeholder="Escoge un tipo de identificación"
                v-model="$v.inspirado.tipoIdentificacion.$model"
                :class="{ 'form-group--error': $v.inspirado.tipoIdentificacion.$error }"
                :isRequired="true"
                :options="tiposDocumento"
            >
                <template v-slot:message-bottom>
                    <span v-if="$v.inspirado.tipoIdentificacion.$dirty && !$v.inspirado.tipoIdentificacion.required" class="text-danger">
                        <small>El tipo de documento es un campo obligatorio</small><br />
                    </span>
                </template>
            </Select>
            <rInput label="Número de identificación"
                placeholder="Escribe tu número de identificación"
                type="number"
                :class="{ 'form-group--error': $v.inspirado.numeroIdentificacion.$error }"
                v-model.number="$v.inspirado.numeroIdentificacion.$model"
                :isRequired="true"
            >
                <template v-slot:message-bottom>
                    <span v-if="$v.inspirado.numeroIdentificacion.$dirty && !$v.inspirado.numeroIdentificacion.required" class="text-danger">
                        <small>El número de documento es un campo obligatorio</small><br />
                    </span>
                    <span v-if="$v.inspirado.numeroIdentificacion.$dirty && !$v.inspirado.numeroIdentificacion.validDocument" class="text-danger">
                        <small>El número de documento ingresado no es válido</small><br />
                    </span>
                </template>
            </rInput>
            <rInput label="Número celular"
                placeholder="Escribe un número celular de contacto"
                :class="{ 'form-group--error': $v.inspirado.telefono.$error }"
                v-model.number="$v.inspirado.telefono.$model"
                :isRequired="true"
            >
                <template v-slot:message-bottom>
                    <span v-if="$v.inspirado.telefono.$dirty && !$v.inspirado.telefono.required" class="text-danger">
                        <small>El teléfono es un campo obligatorio</small><br />
                    </span>
                </template>
            </rInput>
            <rInput label="Correo Electrónico"
                type="email"
                placeholder="Ejemplo: example@example.com"
                v-model.trim="inspirado.correo"
                :class="{ 'form-group--error': $v.inspirado.correo.$error }"
                v-model.number="$v.inspirado.correo.$model"
                :isRequired="true"
            >
                <template v-slot:message-bottom>
                    <span v-if="!$v.inspirado.correo.email" class="text-danger">
                        <small>Email no válido</small><br />
                    </span>
                    <span v-if="$v.inspirado.correo.$dirty && !$v.inspirado.correo.required" class="text-danger">
                        <small>El email es un campo obligatorio</small><br />
                    </span>
                </template>
            </rInput>
            <Select label="Nacionalidad"
                placeholder="Escoge nacionalidad"
                v-model="$v.inspirado.pais.$model"
                :class="{ 'form-group--error': $v.inspirado.pais.$error }"
                :isRequired="true"
                :options="paises"
            >
                <template v-slot:message-bottom>
                    <span v-if="$v.inspirado.pais.$dirty && !$v.inspirado.pais.required" class="text-danger">
                        <small>La nacionalidad es un campo obligatorio</small><br />
                    </span>
                </template>
            </Select>
            <Select label="Departamento de residencia"
                placeholder="Escoge el departamento en el que resides actualmente"
                v-model="$v.inspirado.departamento.$model"
                :nestedObj="true"
                :class="{ 'form-group--error': $v.inspirado.departamento.$error }"
                :isRequired="true"
                :options="departamentos"
                @input="(event) => { inspirado.municipio = ''; calcularMunicipios(); }"
            >
                <template v-slot:message-bottom>
                    <span v-if="$v.inspirado.departamento.$dirty && !$v.inspirado.departamento.required" class="text-danger">
                        <small>El departamento de residencia es un campo obligatorio</small><br />
                    </span>
                </template>
            </Select>
            <Select label="Municipio de residencia"
                v-if="inspirado.departamento"
                placeholder="Escoge el municipio en el que resides actualmente"
                v-model="$v.inspirado.municipio.$model"
                :nestedObj="true"
                :class="{ 'form-group--error': $v.inspirado.municipio.$error }"
                :isRequired="true"
                :options.sync="municipios"
            >
                <template v-slot:message-bottom>
                    <span v-if="$v.inspirado.municipio.$dirty && !$v.inspirado.municipio.required" class="text-danger">
                        <small>El municipio de residencia es un campo obligatorio</small><br />
                    </span>
                </template>
            </Select>
            <rInput label="Dirección o barrio"
                placeholder="Escribe una dirección o solo el barrio"
                :class="{ 'form-group--error': $v.inspirado.direccion.$error }"
                type="text"
                v-model.trim="$v.inspirado.direccion.$model"
                :isRequired="true"
            >
                <template v-slot:message-bottom>
                    <span v-if="$v.inspirado.direccion.$dirty && !$v.inspirado.direccion.required" class="text-danger">
                        <small>La dirección es un campo obligatorio</small><br />
                    </span>
                </template>
            </rInput>
            <Select label="Sexo"
                placeholder="Escoge un sexo"
                v-model="$v.inspirado.genero.$model"
                :class="{ 'form-group--error': $v.inspirado.genero.$error }"
                :isRequired="true"
                :options="generos"
            >
                <template v-slot:message-bottom>
                    <span v-if="$v.inspirado.genero.$dirty && !$v.inspirado.genero.required" class="text-danger">
                        <small>El campo sexo es obligatorio</small><br />
                    </span>
                </template>
            </Select>
            <Select label="Etnia"
                placeholder="Escoge si perteneces a una etnia "
                v-model="$v.inspirado.etnia.$model"
                :class="{ 'form-group--error': $v.inspirado.etnia.$error }"
                :isRequired="true"
                :options="etnias"
            >
                <template v-slot:message-bottom>
                    <span v-if="$v.inspirado.etnia.$dirty && !$v.inspirado.etnia.required" class="text-danger">
                        <small>La etnia es un campo obligatorio</small><br />
                    </span>
                </template>
            </Select>
            <fieldset class="mb-4">
                <legend>
                    <small> <strong>¿Perteneces a alguno de estos grupos?:</strong></small><br />
                    <small> (Se puede seleccionar más de una opción si aplica)</small><br />
                </legend>
                <div class="custom-control custom-checkbox my-1 mr-sm-2">
                    <input type="checkbox" v-model.trim="inspirado.victima" id="victimas" class="custom-control-input">
                    <label class="custom-control-label" for="victimas">Víctimas</label>
                </div>
                <div class="custom-control custom-checkbox my-1 mr-sm-2">
                    <input type="checkbox" v-model.trim="inspirado.discapacidad" id="discapacidad" class="custom-control-input" />
                    <label class="custom-control-label" for="discapacidad">Discapacidad</label>
                </div>
                <div class="custom-control custom-checkbox my-1 mr-sm-2">
                    <input type="checkbox" v-model.trim="inspirado.lgbti" id="lgbti" class="custom-control-input" />
                    <label class="custom-control-label" for="lgbti">LGBTI</label>
                </div>
            </fieldset>
            <div class="text-center">
                <button type="submit" class="btn btn-success">Guardar</button>
            </div>
        </form>
    </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import rInput from '../../components/forms/Input'
import Select from '../../components/forms/Select'
import paises from '../../static-data/paises'
import departamentosList from '../../static-data/departamentos'
import municipios from '../../static-data/municipios'
import { etnias, generos, tiposDocumento } from '../../static-data/listas'
import { inspiradoModel, inspiradoModelValidations } from '../../static-data/inspiradoModel'
import apiInspirados from '../../api/inspirados'

export default {
  components: { rInput, Select },
  props: {
    edition: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      inspirado: { ...inspiradoModel },
      municipios: [],
      facilitadores: [],
      isLogged: false,
      loading: false
    }
  },
  validations () { return { inspirado: inspiradoModelValidations(this.inspirado) } },
  async mounted () {
    if (this.user !== {}) await this.$store.dispatch('user/getUserInfo')
    if (this.user.rol.toLowerCase() === 'merani' || this.user.rol.toLowerCase() === 'admin') {
      if (this.$route.query.key) {
        await this.loadInspirador(this.$route.query.key)
      } else {
        this.$router.push({ path: '/' })
      }
    }
    if (this.edition) {
      const inspiradoDoc = await this.loadInspirado(this.$route.params.id)
      const dataInspirado = inspiradoDoc.data()
      this.inspirado = { ...dataInspirado }
      this.keyInspirado = inspiradoDoc.id
      this.inspirado.departamento = this.departamentos.find(o => dataInspirado.departamento.codigo === o.codigo)
      this.inspirado.departamento = {
        ...this.inspirado.departamento,
        value: this.inspirado.departamento.codigo,
        label: this.inspirado.departamento.nombre
      }
      this.calcularMunicipios()
      this.inspirado.municipio = this.municipios.find(o => dataInspirado.municipio.codigo === o.codigo)
    } else {
      this.inspirado.departamento = this.departamentos.find(o => this.user.departamento.codigo === o.codigo)
      this.inspirado.departamento = {
        ...this.inspirado.departamento,
        value: this.inspirado.departamento.codigo,
        label: this.inspirado.departamento.nombre
      }
      this.calcularMunicipios()
      this.inspirado.municipio = this.municipios.find(o => this.user.municipio.codigoMunicipio === o.codigo)
    }
  },
  methods: {
    async onSubmit (event) {
      if (!this.loading) {
        this.loading = true
        this.$v.$touch()
        if (this.$v.$invalid) {
          alert('Se encontraron errores en el formulario')
          return
        }
        const data = {
          ...this.inspirado,
          departamento: {
            codigo: this.inspirado.departamento.value,
            nombre: this.inspirado.departamento.label
          },
          municipio: {
            codigo: this.inspirado.municipio.value,
            nombre: this.inspirado.municipio.label
          },
          capacitacionRecibida: false
        }
        if (this.edition) {
          try {
            await this.apiInspirados.actualizarInspirado(data, this.keyInspirado)
            this.loading = false
            this.$router.push({ name: 'ver-inspirado', params: { id: this.keyInspirado } })
          } catch (error) {
            alert('Hubo un error')
            this.loading = false
          }
        } else {
          const token = (this.user.rol.toLowerCase() === 'merani' || this.user.rol.toLowerCase() === 'admin')
            ? this.keyInspiradorActual
            : this.token

          this.apiInspirados.guardarNuevoInspirado(data, token)
            .then((response) => {
              alert('Operación correcta')
              this.loading = false;
              (this.user.rol.toLowerCase() === 'merani' || this.user.rol.toLowerCase() === 'admin')
                ? this.$router.push({ name: 'ver-inspirador', params: { id: this.keyInspiradorActual } })
                : this.$router.push({ name: 'inspirados' })
            })
            .catch((err) => {
              alert(err)
              this.loading = false
              console.error(err)
            })
        }
      }
    },
    calcularMunicipios () {
      this.municipios = municipios
        .filter(municipio => this.inspirado.departamento && (municipio.departamento === this.inspirado.departamento.value))
        .map(municipio => ({
          codigo: municipio.codigoMunicipio,
          nombre: municipio.nombreMunicipio,
          departamento: municipio.departamento,
          value: municipio.codigoMunicipio,
          label: municipio.nombreMunicipio
        }))
    },
    loadInspirado (id) {
      return apiInspirados.obtenerInspiradoPorId(id)
    },
    ...mapActions('merani', [
      'loadInspirador'
    ])
  },
  computed: {
    ...mapState('user', [
      'user',
      'token'
    ]),
    ...mapState('merani', [
      'inspiradorActual',
      'keyInspiradorActual'
    ]),
    inspiradoModel () {
      return inspiradoModel
    },
    apiInspirados () {
      return apiInspirados
    },
    paises () {
      return Object.values(paises).map(pais => ({ ...pais, label: pais, value: pais }))
    },
    departamentos () {
      return departamentosList.map(departamento => ({ codigo: departamento.codigo, nombre: departamento.nombre, label: departamento.nombre, value: departamento.codigo }))
    },
    etnias () {
      return etnias
    },
    tiposDocumento () {
      return tiposDocumento
    },
    generos () {
      return generos
    }
  }
}
</script>
